








































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DisplayMixin from '@/mixins/displayTitle'
import {
  getIosAppDetail,
  getAndroidAppDetail,
  getIosAppLogs,
  getAndroidAppLog,
  getIosFileList,
  getAdroidFileList
} from '@/api/files/files-app/filesApp'

@Component({
  name: 'AppDetail'
})
export default class extends mixins(DisplayMixin) {
  // data
  private detail: any = {}
  private logList: any[] = []
  private tableData: any[] = []
  private dataList: any[] = []
  private nodeList: number[] = [0]
  private id!: number
  private currentPage: number = 1
  private pageShow: boolean = true
  private pageSize: number = 20
  private currentTab: number = 1
  private currentType: number = 0
  bgImage: string = ''
  position: number = 1
  private tabList: string[] = ['应用描述', '文件管理', '用户评论']
  private screenWidth: number = 1920
  private switchTab: any[] = [{
    label: '应用详情',
    value: 'app-detail'
  }, {
    label: '更新记录',
    value: 'update-record'
  }, {
    label: '评论',
    value: 'comments'
  }]
  private tabId: string = 'app-detail'
  tableLoading = false
  // lifecycle
  async created() {
    this.screenWidth = window.screen.width
    this.id = Number(this.$route.query.id)
    this.getAppDetail(this.id)
    this.getAppLogs(this.id)
    this.tableLoading = true
    await this.fileManage(this.id)
    // this.handlePaginate()
    this.tableLoading = false
  }
  // methods
  async getAppDetail(id: number) {
    let p = this.$route.query.platform
    const arr = [1, 2, 3]
    let fn = p === 'ios' ? getIosAppDetail : getAndroidAppDetail
    let res = await fn(id)
    this.detail = res.data
    if (this.detail.subscript.length > 0) {
      const { subscript: [{ type, pic_url: url }] } = res.data
      this.bgImage = `url(${url})`
      if (arr.includes(type)) {
        this.position = type
      }
    }
  }
  async fileManage(id: number) {
    let params = {
      fileType: this.currentType,
      page: 0,
      pageCount: 0
    }
    let pageSize = this.pageSize
    this.currentPage = 1
    let currentPage = this.currentPage
    let plat = this.$route.query.platform
    let fn = plat === 'ios' ? getIosFileList : getAdroidFileList
    let res: any = await fn(id, params)
    this.tableData = res.data.dataList || []
    let data = [...(res.data.dataList || [])]
    this.dataList = data.splice((currentPage - 1) * pageSize, pageSize)
    if (this.dataList) {
      let list = [...(this.dataList || [])]
      // let empArr: any[] = []
      // let tid = 0
      // list.forEach(item => {
      //   let obj = {
      //     ...(item || {})
      //   }
      //   if (item.distributeTask) {
      //     item.distributeTask.forEach((_item: any) => {
      //       let _obj = { ...(obj || {}) }
      //       for (let attr in _item) {
      //         _obj[attr] = _item[attr]
      //       }
      //       tid++
      //       empArr.push(_obj)
      //     })
      //     this.nodeList.push(tid)
      //   } else {
      //     tid++
      //     empArr.push(obj)
      //     this.nodeList.push(tid)
      //   }
      // })
      // this.dataList = empArr
      // console.log(this.dataList)
    } else {
      this.dataList = [] // dataList为空的处理
      this.tableData = []
      return
    }
    this.currentPage = 1
    this.tableLoading = false
  }
  async getAppLogs(id: number) {
    let plat = this.$route.query.platform
    let res: any = plat === 'ios' ? await getIosAppLogs(id) : await getAndroidAppLog(id)
    this.logList = res.data.dataList || res.data
  }
  handleEdit() {
    this['$router'].push({
      name: 'EditApp',
      query: {
        id: this.$route.query.id,
        platform: this.plat
      }
    })
  }
  objectSpanMethod({ row, column, rowIndex, columnIndex }: any) {
    let limit = this.currentType === 0 ? 8 : 9
    if (columnIndex < limit) {
      let nodeList = this.nodeList
      if (nodeList.indexOf(rowIndex) > -1) {
        let index = nodeList.indexOf(rowIndex)
        return {
          rowspan: nodeList[index + 1] - nodeList[index],
          colspan: 1
        }
      } else {
        return {
          rowspan: 0,
          colspan: 0
        }
      }
    }
  }
  // tab 切换的方法
  async handleIPApm(n: number) {
    this.tableLoading = true
    this.currentType = n // type切换
    this.currentPage = 1
    this.nodeList = [0]
    this.pageShow = false
    // 由于这里不采用服务端分页,需要前端自己分页,因此每次切换 tab 需要重新渲染一次
    // this.handleCurrentChange(1)
    await this.fileManage(this.id)
    this.pageShow = true
    this.tableLoading = false
  }
  handlePaginate() {
    let list = [...(this.tableData || [])]
    let pageSize = this.pageSize
    let currentPage = this.currentPage
    this.dataList = list
  }
  handleTabChange(index: number) {
    this.currentTab = index
  }
  handleSizeChange(val: number) {
    this.pageSize = val
    this.handlePaginate()
  }
  // 当前页
  handleCurrentChange(val: number) {
    this.currentPage = val
    this.handlePaginate()
  }
  get plat() {
    return this.$route.query.platform
  }
  handleNull(param: any) {
    return param ? (param as any) : ' '
  }
}
